import { createAction } from '@ngrx/store';

export const hideHeader = createAction('[Header Component] Hide Header');
export const showHeader = createAction('[Header Component] Show Header');

export const hideMobileDock = createAction(
  '[Mobile Dock Component] Hide Mobile Dock'
);
export const showMobileDock = createAction(
  '[Mobile Dock Component] Show Mobile Dock'
);

export const hideFooter = createAction('[Footer Component] Hide Footer');
export const showFooter = createAction('[Footer Component] Show Footer');
